// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Configuration } from './../base/ConfigurationComponent';
import { getDefaultSlots } from '@progress/kendo-vue-common';
import { removeUndefinedProps } from '../../utils/main';
/**
 * @hidden
 */

var ChartSeriesLabelsToVue2 = {
  name: 'KendoChartSeriesLabelsTo',
  props: {
    background: String,
    border: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    color: String,
    content: {
      type: Function,
      default: undefined
    },
    font: String,
    format: String,
    margin: {
      type: [Object, Number],
      default: function _default() {
        return undefined;
      }
    },
    padding: {
      type: [Object, Number],
      default: function _default() {
        return undefined;
      }
    },
    position: {
      type: String,
      default: function _default() {
        return undefined;
      },
      validator: function validator(value) {
        return ['center', 'insideBase', 'insideEnd', 'outsideEnd'].includes(value);
      }
    },
    visible: {
      type: Boolean,
      default: undefined
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    var config = removeUndefinedProps(this.$props);
    return this.v3 ? h(Configuration, {
      config: config,
      chartKey: 'to'
    }, function () {
      return defaultSlots;
    }) : h(Configuration, {
      props: {
        config: config,
        chartKey: 'to'
      }
    }, [defaultSlots]);
  }
};
/**
 * @hidden
 */

var ChartSeriesLabelsTo = ChartSeriesLabelsToVue2;
export { ChartSeriesLabelsTo, ChartSeriesLabelsToVue2 };